import React from 'react';
import { useLang } from '../i18n/LanguageContext';
import { LANGUES_DISPONIBLES } from '../i18n';
import { trackCta } from '../lib/track';

/**
 * Sélecteur de langue — un simple <select> natif : accessible au clavier,
 * fonctionne sur mobile sans JavaScript de menu, et ne pèse rien.
 * La valeur affichée est le drapeau + le code (🇫🇷 FR), la liste déroulée
 * donne le nom complet de chaque langue dans sa propre langue.
 *
 * Il ne montre QUE les langues réellement traduites : proposer « Nederlands »
 * pour afficher du français est une promesse non tenue, visible en une seconde.
 * Chaque dictionnaire rempli fait apparaître sa langue tout seul — et s'il n'y
 * a rien à choisir, le sélecteur disparaît.
 */
export default function LanguageSwitcher({ className = '', compact = false }) {
  const { lang, setLang, t } = useLang();

  if (LANGUES_DISPONIBLES.length < 2) return null;

  return (
    <label className={`inline-flex items-center ${className}`}>
      <span className="sr-only">{t('nav.language')}</span>
      <select
        value={lang}
        onChange={(e) => {
          // On mesure la langue CHOISIE. data-cta={`lang:${lang}`} portait la
          // langue COURANTE sur le <select> lui-meme, et la delegation de clic
          // part avant le change : on n'enregistrait que l'ouverture de la
          // liste par quelqu'un deja dans cette langue. Impossible, donc, de
          // savoir vers quelle langue les visiteurs basculent — precisement la
          // question posee.
          trackCta(`lang:vers-${e.target.value}`);
          setLang(e.target.value);
        }}
        aria-label={t('nav.language')}
        className="cursor-pointer rounded-lg border-2 border-primary/30 bg-white px-2 py-2 text-[13px] font-semibold text-text outline-none transition-all hover:border-primary focus-visible:ring-2 focus-visible:ring-primary/40"
      >
        {LANGUES_DISPONIBLES.map((l) => (
          <option key={l.code} value={l.code}>
            {compact ? `${l.flag} ${l.code.toUpperCase()}` : `${l.flag} ${l.code.toUpperCase()} — ${l.label}`}
          </option>
        ))}
      </select>
    </label>
  );
}
